module.exports = __webpack_public_path__ + "c9194324dbeb62e23db99e4932049b15.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/left_hand/nail-polish.png
// module id = 2862
// module chunks = 0